import { render, staticRenderFns } from "./SearchOtherProducts.vue?vue&type=template&id=df12a650&"
import script from "./SearchOtherProducts.vue?vue&type=script&lang=js&"
export * from "./SearchOtherProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports